function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/storage';
import { mapState, mapMutations } from 'vuex';
import RolesComponent from '@/apps/data-platform/modules/profile/components/RolesComponent';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import BaseLoadingComponent from '@/components/common/BaseLoadingComponent';
import tasks from '@/js/tasks';
export default {
  name: 'MyProfilePage',
  components: {
    RolesComponent: RolesComponent,
    BaseLoadingComponent: BaseLoadingComponent
  },
  data: function data() {
    var _this = this;
    return {
      tab: 0,
      edit: false,
      valid: true,
      rules: {
        displayName: [function (v) {
          return !!v || _this.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this.translate('reglas.nombre_max');
        }],
        phoneNumber: [function (v) {
          return !!v || _this.translate('reglas.phone_required');
        }]
      },
      user: {},
      isLoadingProfile: false,
      isUploadingImage: false,
      selectedImage: null,
      uploadValue: 0,
      isUpdatingProfile: false,
      showMenu: false,
      options: [{
        title: 'Upload image'
      }],
      isHovered: false,
      searchs: []
    };
  },
  created: function created() {
    var _this2 = this;
    this.isLoadingProfile = true;
    var email = this.$route.params.email || window.userInfo.email;
    userSettingsService.getProfile(email).then(function (response) {
      // Un perfil nuevo (ej. usuario que entró por enlace al correo) puede venir
      // vacío o sin historial: no debe dejar la vista cargando para siempre
      var data = response && response.data || {};
      _this2.user = _objectSpread({
        email: email
      }, data);
      // el backend puede devolver null explícito en perfiles nuevos
      if (_this2.user.displayName == null) {
        _this2.user.displayName = window.userInfo.displayName || '';
      }
      if (_this2.user.photoURL == null) {
        _this2.user.photoURL = window.userInfo.photoURL || '';
      }
      _this2.searchs = Array.isArray(data.search) ? data.search.filter(function (item) {
        return item && item.status;
      }) : [];
    }).catch(function (e) {
      console.error(e);
      tasks.toast.error(_this2.translate('error_messages.error_general'));
    }).finally(function () {
      _this2.isLoadingProfile = false;
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('data-platform', ['setDefaultLanguage'])), {}, {
    translate: function translate(key) {
      return this.$i18n.t(key);
    },
    onButtonUploadImageClick: function onButtonUploadImageClick() {
      this.uploadValue = 0;
      this.$refs.uploader.click();
    },
    onFileChanged: function onFileChanged(event) {
      this.selectedImage = event.target.files[0];
      this.user.photoURL = URL.createObjectURL(this.selectedImage);
    },
    onInputPhone: function onInputPhone(formattedNumber, _ref) {
      var number = _ref.number,
        valid = _ref.valid,
        country = _ref.country;
      this.user.phoneNumber = number.e164;
    },
    onUpdateProfile: function onUpdateProfile() {
      var _this3 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isUpdatingProfile = true;
      this.isUploadingImage = true;
      var uploadPromise = new Promise(function (resolve, reject) {
        if (_this3.selectedImage) {
          var storageRef = firebase.storage().ref("profile_images/".concat(_this3.userEmail, "/").concat(_this3.selectedImage.name)).put(_this3.selectedImage);
          storageRef.on('state_changed', function (snapshot) {
            _this3.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            console.log(_this3.uploadValue);
          }, function (error) {
            console.error(error.message);
          }, function () {
            _this3.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then(function (url) {
              console.log("Image url: ".concat(url));
              _this3.isUploadingImage = false;
              _this3.user.photoURL = url;
              resolve();
            }).catch(function (error) {
              reject(error);
            });
          });
        } else {
          resolve();
        }
      });
      uploadPromise.then(function () {
        userSettingsService.updateProfile(_this3.userEmail, _this3.user).then(function (response) {
          window.userInfo.displayName = _this3.user.displayName ? _this3.user.displayName : '';
          window.userInfo.photoURL = _this3.user.photoURL;
          _this3.setDefaultLanguage(_this3.user.defaultLanguage);
          _this3.userInfo = window.userInfo;
          tasks.toast.success(_this3.translate('frases.successfully_updated'));
          //this.$toast.success(this.translate('frases.successfully_updated'))
          _this3.edit = false;
          _this3.selectedImage = null;
          _this3.isUploadingImage = false;
          _this3.isUpdatingProfile = false;
        });
      });
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['defaultLanguage'])), {}, {
    iconEdit: function iconEdit() {
      var icon = this.edit ? 'close' : 'pencil-outline';
      return "mdi-".concat(icon);
    },
    headers_history: function headers_history() {
      return [{
        text: "Búsqueda",
        value: 'texto',
        class: 'text-center'
      }, {
        text: "Fecha",
        value: 'date',
        class: 'text-center'
      }];
    }
  })
};